export const DEFAULT_PRIMARY_COLOR = '#006bf2'

export const DEFAULT_SEMANTIC_COLORS = Object.freeze({
  info: '#2196F3',
  warning: '#FB8C00',
  success: '#4CAF50',
  error: '#FF5252',
})

export const SEMANTIC_COLOR_KEYS = Object.keys(DEFAULT_SEMANTIC_COLORS)

export const resolveSemanticColors = customizacao =>
  SEMANTIC_COLOR_KEYS.reduce(
    (colors, key) => ({ ...colors, [key]: customizacao?.[`color_${key}`] || DEFAULT_SEMANTIC_COLORS[key] }),
    {}
  )
